import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForcedDraftCoolingTower = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 99,
	height: 99,
	viewBox: "0 0 99.0 99.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 0.0 99.0 L 0.0 89.5 L 19.5 89.5 L 19.5 0.0 L 79.5 0.0 L 79.5 89.5 L 99.0 89.5 L 99.0 99.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 9.5 89.5 L 9.5 64.5 L 19.5 64.5 M 89.5 89.5 L 89.5 64.5 L 79.5 64.5 M 19.5 89.5 L 79.5 89.5",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgForcedDraftCoolingTower;
